<app-header />
<main class="flex-column">
  <app-side-nav />
</main>
<app-footer />
